import { Component, input, ChangeDetectionStrategy, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { AlertSeverityComponent } from 'app/alerts/components/alert-severity/alert-severity.component';
import { IconComponent } from 'app/shared/components/icons/icon/icon.component';
import { FormatPipe } from 'app/shared/pipes/format.pipe';
import { FavoritesStore } from 'app/site-favorite/favorites.store';
import { FavoriteSite } from 'app/site-favorite/models/favorite-site';
import { GatewayIconComponent } from 'app/site-gateway/components/gateway-icon/gateway-icon.component';

@Component({
    selector: 'app-favorite-item',
    imports: [GatewayIconComponent, AlertSeverityComponent, IconComponent, FormatPipe, RouterLink, TranslatePipe],
    templateUrl: './favorite-item.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './favorite-item.component.scss',
})
export class FavoriteItemComponent {
    private readonly favorites = inject(FavoritesStore);

    readonly favoriteSite = input.required<FavoriteSite>();
    readonly editMode = input(false);

    onDeleteFavorite($event: Event): void {
        $event.stopPropagation();
        $event.preventDefault();

        void this.favorites.remove(this.favoriteSite().siteId);
    }
}
